
<template>
    <div v-if="isShow">
        <div onload="hidespinner()">
            <div id="loading-spinner"></div>
        </div>
    </div>
</template>

<script>
    import * as config from '../services/config'
    export default {
        data: function() {
            return {
                loading: config.rootURL + '/Content/images/lpgLoading.gif',
                show: true
            }
        },
        props: ['isShow']
    }
</script>
